export var Region;
(function (Region) {
    Region["EEA"] = "EEA, Turkey and Northern Ireland";
})(Region || (Region = {}));
//# sourceMappingURL=regions.js.map